import React, { Component } from 'react';

class ProgressBar extends Component {
  render() {
    const currentIndex = this.props.questions.indexOf(this.props.actualQuestion) + 1;
    const quantity = this.props.questions.length;
    return (
        <div className={`progress-bar ${this.props.type === 'dark' ? 'progress-bar--dark': ''}`}>
            <div className="progress-bar__label">{currentIndex}/{quantity}</div>
            <ul className="progress-bar__list" aria-hidden="true">
            {  this.props.questions.map( (question, index) => (
                <li 
                    key={index} 
                    className={`progress-bar__item ${(index + 1) === currentIndex ? 'progress-bar__item--active' : ''}`}></li>
            ))}
            </ul>
        </div>
    )
  }

}

export default ProgressBar;
